import type { IUser } from '@/models/users';
import { getActiveMerchantId } from '@/utils/axios.utils';
import type {
  ModelUserResponse,
  UserServiceApiUserServiceCreateRequest,
  UserServiceApiUserServiceUpdateRequest,
} from '@layup/api-sdk';
import { userServiceClient } from './auth';
import { createLayupClient } from './layupApi';

export const updateUser = async (
  userId: string,
  user: Partial<IUser>,
  isRealtimeVerification = false,
): Promise<IUser> => {
  const client = createLayupClient();
  const response = await client.put(`v1/users/${userId}?isRealtimeVerification=${isRealtimeVerification}`, user);
  return response.data as IUser;
};

export const getUsersByMerchant = async (): Promise<ModelUserResponse[]> => {
  const response = await userServiceClient().userServiceGetMany();
  return response.data.users as ModelUserResponse[];
};

export const updateMerchantUser = async (
  params: UserServiceApiUserServiceUpdateRequest,
): Promise<ModelUserResponse> => {
  const config = getActiveMerchantId();
  const response = await userServiceClient().userServiceUpdate(params, config);
  return response.data;
};

export const addMerchantUser = async (params: UserServiceApiUserServiceCreateRequest) => {
  const response = await userServiceClient().userServiceCreate(params);
  return response.data;
};
